import { ReactComponent as Icon } from 'icons/shield-search-white.svg';
import { useTranslations } from '../../utils';

const DocumentInVerificationBanner = () => {
  const i18n = useTranslations();
  return (
    <div
      data-testid="doc-verify-banner"
      className="left-[50%] rounded bg-[#1B2733] text-center text-white mb-[15px]"
    >
      <Icon className="my-2.5 mr-1" />
      <span className="text-sm">
        {i18n.t('documentCollector.verifyingDocuments')}
      </span>
    </div>
  );
};

export { DocumentInVerificationBanner };
